export default {
      id: "chevron-up-usage",
      viewBox: "0 0 16 9",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#chevron-up",
      toString: function () {
        return this.url;
      }
    }